interface SparkProps {
  color?: string;
}

const Spark: React.FC<SparkProps> = ({ color = "white" }) => {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.99853 0.5C7.99853 0.5 8.19423 4.20732 10.1454 6.15854C12.0967 8.10976 15.9985 8.5 15.9985 8.5C15.9985 8.5 12.0967 8.89024 10.1454 10.8415C8.19423 12.7927 7.99853 16.5 7.99853 16.5C7.99853 16.5 7.39511 12.8119 5.46252 10.8415C3.52994 8.87104 -0.00146484 8.5 -0.00146484 8.5C-0.00146484 8.5 3.5113 8.10976 5.46252 6.15854C7.41374 4.20732 7.99853 0.5 7.99853 0.5Z"
        fill={color}
      />
    </svg>
  );
};

export default Spark;
